<!-- This empty div will keep background of parent centered when the container is below image size -->
<div></div>
